module.exports = __webpack_public_path__ + "img/rl-second1.a65f76eb.png";